var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1488_31478)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7031 0.051327C17.7896 0.505384 8.73007 7.10542 5.02734 10.3487C6.18309 14.0206 8.79192 18.7586 10.4598 24.2136C12.5363 31.005 13.5786 38.5429 14.5139 41.2407C19.7842 31.7542 33.9734 24.2947 42.1627 27.7812C50.3519 31.2677 52.5411 26.9704 53.433 25.8353L53.4629 25.7971C54.394 24.6109 57.5427 20.5994 62.5952 23.7271C65.5 25.5253 71 24 72.0007 22.5109C67.1358 21.4568 64.4601 17.4838 62.352 14.7271C60.2439 11.9703 56.1087 5.15947 50.5952 7.10541C45.0816 9.05135 42.0005 6.53785 40.3789 5.15947C38.7573 3.78108 35.5951 -0.516244 25.7031 0.051327Z",
    fill: "#78CA95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6751 11.1596C29.4318 10.7542 28.3778 9.94342 27.2426 9.94342C26.1075 10.1056 25.7021 11.1596 25.9453 11.5651C26.1886 11.9705 26.594 11.7272 27.4859 11.5651C28.3778 11.4029 28.7021 11.9705 29.1886 12.1326C29.6751 12.2948 29.9183 11.5651 29.6751 11.1596Z",
    fill: "#558F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1317 13.0222C41.396 12.7085 42.179 11.9415 43.3831 12.3162C44.333 12.6117 44.6412 13.4444 44.2705 13.8842C44.0061 14.1978 43.6925 13.9336 42.9509 13.6716C42.2094 13.4096 41.8532 13.851 41.4142 13.9228C40.9751 13.9945 40.8674 13.3359 41.1317 13.0222Z",
    fill: "#558F69"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5252 15.8383C31.2878 15.5331 30.848 15.4781 30.5429 15.7155C30.2377 15.9528 30.1827 16.3926 30.4201 16.6978C31.5636 18.1681 33.6876 20.6073 37.1164 20.6975C39.9861 20.7731 41.4861 18.6476 41.788 17.4065C41.8794 17.0308 41.6489 16.6522 41.2733 16.5608C40.8976 16.4695 40.519 16.6999 40.4276 17.0756C40.2431 17.8344 39.2133 19.3522 37.1532 19.298C34.4199 19.2261 32.6519 17.2869 31.5252 15.8383Z",
    fill: "#558F69"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.39685,
    y: 3.62811,
    width: 1.62163,
    height: 63.4058,
    transform: "rotate(-17 1.39685 3.62811)",
    fill: "#474354"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4.05469,
    width: 4.54057,
    height: 1.62163,
    rx: 0.810816,
    transform: "rotate(-17 0 4.05469)",
    fill: "#474354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89209 11.7271C3.18293 11.3217 3.73944 10.2989 5.51376 10.1866",
    stroke: "#78CA95",
    strokeWidth: 0.621622
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2252 42.4571C12.6264 42.073 13.0963 41.104 14.5943 40.9976",
    stroke: "#78CA95",
    strokeWidth: 0.621622
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 63.1123C43.5 63.8679 47.5 64.2213 52.5 61.5771C62.3867 56.3485 67.5 74.1541 82 74.5319L80.5 84H-1V64.9572C0.833336 64.5794 6.2 59.022 11 56C17 52.2225 21 52.6465 25 53.7798C29 54.913 39.5 62.3568 41.5 63.1123Z",
    fill: "url(#paint0_linear_1488_31478)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1488_31478",
    x1: 49,
    y1: 30.7126,
    x2: 47.2533,
    y2: 75.1279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1488_31478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.7c1638a507caaf71bf35d6f39b0cf3b7.svg";
export { ForwardRef as ReactComponent };